import { takeEvery } from "@redux-saga/core/effects";

import { ILayoutActionTypes } from "../types";
import { updateLayoutSaga } from "./updateLayoutSaga";

export default function* authSaga() {
    yield takeEvery(ILayoutActionTypes.UPDATE_LAYOUT_REQUEST, updateLayoutSaga);
}
